import { Sheet, SheetContent, SheetHeader, SheetTitle } from "./ui/sheet";
import { OutcomeForm } from "./OutcomeForm";

export const OutcomeSheet = ({ appointmentId, session, onClose, onSaved, onPositive, onMove }) => <Sheet open={Boolean(appointmentId)} onOpenChange={(next) => { if (!next) onClose(); }}>
  <SheetContent side="bottom" className="hud-sheet outcome-sheet" closeTestId="outcome-close-button" data-testid="outcome-sheet">
    <div className="sheet-grab" aria-hidden="true" />
    <SheetHeader><SheetTitle className="sr-only">Esito incontro</SheetTitle></SheetHeader>
    {appointmentId && <OutcomeForm key={appointmentId} appointmentId={appointmentId} csrfToken={session.csrf_token}
      onBack={onClose} onSaved={(result) => { onSaved(result); onClose();
        if (["interested", "positive"].includes(result.outcome_code) && result.meeting_number === 1) onPositive?.(result);
        if (["not_present", "busy", "rescheduled"].includes(result.outcome_code)) onMove?.(result);
      }} />}
  </SheetContent>
</Sheet>;